//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import form from '~/mixins/components/form';

export default {
  name: 'booking-dimension-form',
  mixins: [form],
  props: {
    validation: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isEditActive: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return { localeKey: 'booking.cargo' };
  },
  computed: {
    volumeMask () {
      return this.request.volumeMask;
    },
  },
  methods: {
    isError (field, serverField) {
      return (this.validation &&
        this.validation[field] &&
        this.validation[field].$dirty &&
        this.validation[field].$error) ||
        (!!serverField && !!this.serverError(serverField)) ||
        !!this.serverError(field);
    },
    errorText (field, serverField) {
      let clientError = '';
      if (this.validation &&
        this.validation[field] &&
        this.validation[field].$params
      ) {
        Object.keys(this.validation[field].$params)
          .sort((paramA, paramB) => paramA === 'required' ? -1 : paramB === 'required' ? 1 : 0)
          .every(param => {
            if (!this.validation[field][param]) {
              clientError = this.$t(`errors.${param}`);
              return false;
            }
            return true;
          });
      }
      return this.serverError(field) ||
        (serverField && this.serverError(serverField)) ||
        clientError;
    },
  },
};
